/* eslint-disable max-len */
import {
  LinkedReference,
  Reference as RQReference,
} from '@1po/1po-bff-fe-spec/generated/basket/request/model/Reference';
import { AddReferenceByRefNumber } from '@1po/1po-bff-fe-spec/generated/basket/response/AddReferenceByRefNumber';
import { BasketResponse } from '@1po/1po-bff-fe-spec/generated/basket/response/BasketResponse';
import { InvalidReferenceQuantityUpdateResponse } from '@1po/1po-bff-fe-spec/generated/basket/response/InvalidReferenceQuantityUpdateResponse';
import { Reference } from '@1po/1po-bff-fe-spec/generated/basket/response/model/Reference';
import { OtherReferenceMoveToVehicleConfirmResponse } from '@1po/1po-bff-fe-spec/generated/basket/response/OtherReferenceMoveToVehicleConfirmResponse';
import { OtherReferenceMoveToVehicleResponse } from '@1po/1po-bff-fe-spec/generated/basket/response/OtherReferenceMoveToVehicleResponse';
import { UploadReferencesFileResponse } from '@1po/1po-bff-fe-spec/generated/basket/response/UploadReferencesFileResponse';
import { ReferenceKey } from '@1po/1po-bff-fe-spec/generated/catalog/references/common/model/ReferenceKey';
import { ReferenceBrandType } from '@1po/1po-bff-fe-spec/generated/catalog/references/iam/model/Reference';
import { ReferenceStock } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/model/ReferenceStock';
import {
  UPLOAD_BASKET_REFERENCES_FILE_ERROR_99_REFERENCES,
  UPLOAD_BASKET_REFERENCES_FILE_ERROR_API_CALL,
  UPLOAD_BASKET_REFERENCES_FILE_ERROR_TECHNICAL,
  UPLOAD_BASKET_REFERENCES_FILE_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { WsResponse } from '@1po/1po-bff-fe-spec/generated/common/WsResponse';
import { all, call, delay, put, race, take, takeEvery } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import { ROUTER_CART } from 'app/AppRouter';
import { RootState } from 'app/AppStore';
import { calculateUrgentDeliveryAddition } from 'components/Discount';
import { NO_FILE, TECHNICAL_ERROR } from 'components/FileUpload/paramsByState';
import { getIsBulkOilUser, getIsOilChunkUserR1 } from 'domains/appContext/AppContext.requests';
import {
  ExternalBasketSectionLocal,
  OtherSectionLocal,
  REF_ATTACH_CHECKING,
  REF_ATTACH_NON_COMPATIBLE,
  REF_ATTACH_OK,
  ReferenceLocal as BasketReferenceLocal,
  STATUS_MISSING_PRICE,
  STATUS_NOT_ALLOWED,
  STATUS_NOT_IN_STOCK,
  STATUS_REFERENCE_DOES_NOT_EXIST,
  STATUS_SUCCESS,
  STATUS_TRACTION_BATTERY_ALREADY_IN_BASKET,
  STATUS_UNKNOWN_REFERENCE,
  STATUS_VIN_NON_COMPLIANT,
  STATUS_ZE_READY_REQUIRED,
  CrossSellingAddToBasketTrackedReference,
  VehicleLocal,
} from 'domains/basket/Basket.types';
import { getLastVehicleDetail, getPlateReference, getVehicleContext } from 'domains/catalog/Catalog.store';
import { PlateReferencesDetail, STANDARD } from 'domains/catalog/Catalog.types';
import { disablePopins } from 'domains/firstHelp/FirstHelp.store';
import {
  DHReferenceLocal,
  getDHReference,
  getDHReferences,
  getDiscount,
  getIAMReference,
  getIAMReferences,
  getPrice,
  getStockInfo,
  getStocksMapV2,
  IAMReferenceLocal,
  matchesReferenceKey,
  NON_MKTP,
  ReferenceLocal,
} from 'domains/references';
import { isRefNumberDeposit } from 'domains/references/DepositReference';
import * as referenceActions from 'domains/references/References.store';
import { getTireSetParam } from 'domains/tires/Tire.store';
import { getFirstImageUrl } from 'pages/CatalogPage/IAM/SubcategorySection/SparePartsSection/ReferenceCardsContainer/PlateReferenceCard/IAMPlateReferenceCard';
import { notifyTop } from 'UI';
import { AppTranslation, FOUND, getData, getSearchData, LOADING, sagaGuard, select } from 'utils';
import { hasUserAnyRight, isSingleUnitOrderRestrictedFamily } from 'utils/rights';
import {
  getTractionBatteryBlockedMessage,
  getTractionBatteryUploadErrorMessages,
  TRACTION_BATTERY_VIN_NON_COMPLIANT_DEFAULT_MESSAGE,
} from 'utils/rights/tractionBatteryOrder';
import {
  attachOtherNonApplicableReferenceToVehicle,
  attachOtherReferenceToVehicle,
  notifyUserAboutExpiredDiscounts,
  sendAddReferenceByRefNumber,
  sendAddReferences,
  sendGetBasket,
  sendRemoveReferencesRequest,
  sendRemoveSingleReference,
  sendRevertAttachOtherReference,
  sendRevertLastRemoval,
  sendSetReferenceMark,
  sendUpdateAllUrgencyFlags,
  sendUpdateOrderMark,
  sendUpdateReferenceQuantity,
  sendUpdateUrgencyFlag,
  sendUploadReferencesFileRequest,
} from './Basket.api';
import { getTradingDataMap, mapTire } from './Basket.mapper';
import * as actions from './Basket.store';
import {
  addOtherReference,
  addVehicleReferences,
  getBasketExadisDeliveryMode,
  getBasketExternalSection,
  getBasketHasTractionBatteryForVehicle,
  getBasketIAMWithoutMotrioReferences,
  getBasketId,
  getBasketIdStatus,
  getBasketOtherSection,
  getBasketReferenceTradingData,
  getBasketVehicles,
  moveOtherReferenceToVehicle,
  removeReference,
  removeReferences,
  setActionStatus,
  setBasket,
  setBasketIdStatus,
  setFileReferencesUploadStatusErrorRows,
  setFileReferencesUploadStatusIsModalOpen,
  setFileReferencesUploadStatusModalStatus,
  setOtherReferenceAttachStatus,
  updateReferenceQuantity,
  updateTradingDataMap,
} from './Basket.store';
import { getUserContext, getUserRights, UserRole } from '../user';

const UPLOAD_REFERENCES_FILE_TIMEOUT_MS = 60000;

type CrossSellingOriginContext = {
  mainReferenceNumber?: string;
  mainReferenceFamilyCode?: string;
  mainReferenceSegmentMarketing?: string;
};

type CrossSellingRequestReference = RQReference;

type MapReferenceOptions = {
  isCrossSelling: boolean;
  isFromProductPage: boolean;
  crossSellingOrigin?: CrossSellingOriginContext;
  sellerNumber?: string;
  sellerName?: string;
  stockData?: ReferenceStock;
};

export function* fetchBasketRequest(): SagaIterator {
  yield put(setBasketIdStatus(LOADING));
  yield put(sendGetBasket());
}

export function* fetchBasketResponse(action: WsResponse<BasketResponse>): SagaIterator {
  const { basketId, vehicles, otherSection, expiredReferenceDiscounts, externalBaskets } = action.payload;
  const currentTradingData = yield* select(getBasketReferenceTradingData);
  const basketExadisDeliveryMode = yield* select(getBasketExadisDeliveryMode);
  const basketIAMWithoutMotrioReferences = yield* select(getBasketIAMWithoutMotrioReferences);
  const basketIAMWithoutMotrioReferenceNumbers = basketIAMWithoutMotrioReferences.map((l) => l.referenceNumber);
  const allStocksBasketIAMWithoutMotrioReferences = yield* select((state: RootState) =>
    getStocksMapV2(state, basketIAMWithoutMotrioReferenceNumbers),
  );

  const isBasketVehicles = vehicles.length > 0;
  const isBasketOthers = otherSection.references.length > 0;

  if (!isBasketVehicles && !isBasketOthers) {
    yield put(disablePopins([`${ROUTER_CART}_add_comment`, `${ROUTER_CART}_link_to_veh`]));
  }
  if (!isBasketOthers || (isBasketOthers && !isBasketVehicles)) {
    yield put(disablePopins([`${ROUTER_CART}_link_to_veh`]));
  }
  const isBulkOilUser: boolean = yield* select(getIsBulkOilUser);
  const isOilChunkUserR1: boolean = yield* select(getIsOilChunkUserR1);
  yield put(
    setBasket({
      basketId,
      vehicles,
      otherSection,
      expiredReferenceDiscounts,
      rememberIsSelected: true,
      externalBaskets,
      isBulkOilUser,
      isOilChunkUserR1,
    }),
  );

  yield put(updateTradingDataMap({ vehicles, otherSection, externalBaskets, isBulkOilUser, isOilChunkUserR1 }));

  // fetch missing prices and stocks for basket
  const tradingDataMap = getTradingDataMap(vehicles, externalBaskets, otherSection, isBulkOilUser, isOilChunkUserR1);
  const missingReferences = [...tradingDataMap.values()].filter(
    (ref) => currentTradingData.get(ref.referenceNumber) === undefined,
  );

  const stockDiff = [...tradingDataMap.values()]
    .filter((ref) => {
      const previous = currentTradingData.get(ref.referenceNumber);
      return previous?.quantity !== ref.quantity;
    })
    .map((ref) => {
      return {
        referenceNumber: ref.referenceNumber,
        type: ref.type,
        quantity: ref.quantity,
        origin: ref.origin,
        supplierCode: ref.supplierCode,
        referenceSource: ref.referenceSource,
        isCertasReference: ref.isCertasReference,
        isPrimaryStockRequest:
          basketExadisDeliveryMode &&
          ref.origin === 'IAM' &&
          ref.brand !== 'MOTRIO' &&
          !allStocksBasketIAMWithoutMotrioReferences
            ?.get(ref.referenceNumber)
            ?.data?.get(ref.sellerNumber ?? NON_MKTP)
            ?.warehouses.some((w) => w.type === 'LOCAL' && w.confirmedQuantity > 0),
      };
    });
  if (missingReferences.length > 0) {
    yield put(
      referenceActions.fetchReferencesPriceRequestSaga({
        references: missingReferences.map((r) => {
          return {
            referenceNumber: r.referenceNumber,
            commercialFamily: r.commercialFamily,
            supplierCode: r.supplierCode,
            origin: r.origin,
            referenceSource: r.referenceSource,
          };
        }),
        basketRequest: true,
      }),
    );
  }
  if (stockDiff.length > 0) {
    yield put(
      referenceActions.fetchReferencesStocksRequestSaga({
        data: stockDiff,
        fetchEvenIfExists: true,
      }),
    );
  }
}

export function* mapReference(
  reference: ReferenceLocal,
  options: MapReferenceOptions,
): Generator<unknown, CrossSellingRequestReference, never> {
  const { isCrossSelling, isFromProductPage, sellerNumber, sellerName, stockData } = options;
  const discount = yield* select((state: RootState) => getDiscount(state, reference.referenceNumber));
  const priceSelect = yield* select((state: RootState) =>
    getPrice(state, reference.referenceNumber, reference.sellerNumber),
  );
  const price = getData(priceSelect);
  const catalogSource = reference.source === 'dh' ? 'DATAHUB' : 'IAM';
  const name = reference.source === 'iam' ? mapIAMReferenceName(reference) : mapDHReferenceName(reference);
  const brand = reference.source === 'iam' ? mapIAMReferenceBrand(reference) : reference.brand;
  const imageUrl = reference.source === 'iam' ? mapIAMReferenceImage(reference) : mapDHReferenceImage(reference);
  return {
    referenceNumber: reference.referenceNumber,
    name: name ?? '',
    price: {
      priceVatExcluded: price?.garageView?.vatExcludedPrice?.toString() ?? '0',
      priceVatIncluded: price?.garageView?.vatIncludedPrice?.toString() ?? '0',
      vatExcludedUrgentDeliveryAdditionalPrice: calculateUrgentDeliveryAddition(price, discount, false).toString(),
      vatIncludedUrgentDeliveryAdditionalPrice: calculateUrgentDeliveryAddition(price, discount, true).toString(),
    },
    quantity: 1,
    brand: brand ?? 'OTHER',
    familyCode: (reference.source === 'dh' ? reference.familyCode : reference.commercialFamily) ?? '',
    productModelCode: reference.source === 'dh' ? reference.productModelCode : undefined,
    segmentMarketing: (reference.source === 'dh' ? reference.segmentMarketing : '') ?? '',
    isCompatible:
      reference.source === 'dh'
        ? reference.isApplicableToCurrentVehicle ?? false
        : reference.isBatteryCompatibleWithVehicle ?? true,
    type: reference.type,
    origin: reference.source === 'iam' ? reference.origin : undefined,
    supplier: reference.source === 'iam' ? reference.supplier : undefined,
    supplierCode: reference.source === 'iam' ? reference.supplierCode : undefined,
    referenceSource: reference.source === 'iam' ? reference.referenceSource : undefined,
    tireDimensions: reference.source === 'dh' ? reference?.tireDetails?.designation : undefined,
    technicalCharacteristics:
      reference.source === 'dh' ? reference?.characteristics?.technicalCharacteristics : undefined,
    catalogSource,
    imageUrl,
    isCrossSelling,
    isFromProductPage,
    sellerNumber,
    sellerName,
    stockDetail: {
      warehouses: stockData?.warehouses ?? [],
    },
  };
}

export const mapIAMReferenceName = (ref: IAMReferenceLocal): string => {
  const rawSupplier = ref.supplierReferences?.filter((r) => r.type === 'RAW');
  const designation = ref.designation ?? '';
  const displayName = ref.name ?? designation;
  const rawLabel = rawSupplier && rawSupplier.length > 0 ? rawSupplier[0].id : null;

  const displayLabel = ref.supplier && displayName ? `${displayName} - ${ref.supplier}` : displayName || ref.supplier;

  if (ref.supplier !== 'MOTRIO') {
    return `${displayLabel ?? ''} ${rawLabel ?? ''}`.trim();
  }

  return displayLabel ?? '';
};

export const mapDHReferenceName = (dhRef: DHReferenceLocal): string | undefined => {
  return dhRef.type === STANDARD ? dhRef.name : dhRef?.tireDetails?.profile;
};

export const mapDHReferenceImage = (ref: DHReferenceLocal): string | undefined => {
  return ref.imageKeys && ref.imageKeys?.length > 0 ? ref.imageKeys[0] : undefined;
};

export const mapIAMReferenceImage = (ref: IAMReferenceLocal): string | undefined => {
  return getFirstImageUrl(ref);
};

export const mapIAMReferenceBrand = (ref: IAMReferenceLocal): ReferenceBrandType | undefined => {
  if (ref.supplier === 'MOTRIO') {
    return 'MOTRIO';
  }
  return undefined;
};

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
export function* mapLinkedReference(
  reference: ReferenceLocal,
  quantityRatio: number,
): Generator<unknown, LinkedReference, never> {
  const discount = yield* select((state: RootState) => getDiscount(state, reference.referenceNumber));
  const priceSelect = yield* select((state: RootState) => getPrice(state, reference.referenceNumber));
  const price = getData(priceSelect);
  const imageUrl = reference.source === 'iam' ? mapIAMReferenceImage(reference) : mapDHReferenceImage(reference);
  return {
    referenceNumber: reference.referenceNumber,
    name: reference.name ?? '',
    price: {
      priceVatExcluded: price?.garageView?.vatExcludedPrice?.toString() ?? '0',
      priceVatIncluded: price?.garageView?.vatIncludedPrice?.toString() ?? '0',
      vatExcludedUrgentDeliveryAdditionalPrice: calculateUrgentDeliveryAddition(price, discount, false).toString(),
      vatIncludedUrgentDeliveryAdditionalPrice: calculateUrgentDeliveryAddition(price, discount, true).toString(),
    },
    brand: reference.brand ?? 'OTHER',
    familyCode: reference.source === 'dh' ? reference.familyCode ?? '' : '',
    isCompatible:
      reference.source === 'dh'
        ? reference.isApplicableToCurrentVehicle ?? false
        : reference.isBatteryCompatibleWithVehicle ?? true,
    type: reference.type,
    imageUrl,
    quantityRatio,
  };
}

export function* mapReferences(
  ref: ReferenceLocal,
  plateRef: PlateReferencesDetail | undefined,
  vehicleKey: string | undefined,
  options?: Omit<MapReferenceOptions, 'stockData'>,
): Generator<unknown, CrossSellingRequestReference, never> {
  const {
    isCrossSelling: isCrossSellReference = false,
    isFromProductPage = false,
    crossSellingOrigin,
    sellerNumber,
    sellerName,
  } = options ?? { isCrossSelling: false, isFromProductPage: false };
  const stock = yield* select((state: RootState) => getStockInfo(state, ref.referenceNumber, ref.sellerNumber));
  const stockData = getSearchData(stock);
  const linkedReferenceNumbers = (plateRef ?? ref).linkedReferences?.map((linkedRef) => linkedRef.referenceNumber);
  const linkedRefsDh = yield* select((state: RootState) =>
    getDHReferences(state, {
      vehicleKey,
      referenceNumbers: linkedReferenceNumbers ?? [],
    }),
  );

  const linkedRefsIam = yield* select((state: RootState) =>
    getIAMReferences(state, {
      vehicleKey,
      referenceNumbers: linkedReferenceNumbers ?? [],
    }),
  );

  const linkedRefs = ref.source === 'dh' || linkedRefsIam.length === 0 ? linkedRefsDh : linkedRefsIam;

  const reference: CrossSellingRequestReference = yield call(mapReference, ref, {
    isCrossSelling: isCrossSellReference,
    isFromProductPage,
    crossSellingOrigin,
    sellerNumber: ref.sellerNumber ?? sellerNumber,
    sellerName: ref.sellerName ?? sellerName,
    stockData,
  });

  reference.linkedReferences = yield all(
    linkedRefs.map((r) => {
      const linkedRefDetail = ref.linkedReferences?.find(
        (linkedRef) => linkedRef.referenceNumber === r.referenceNumber,
      );

      const quantityRatio = linkedRefDetail?.ratio ?? 1;
      return call(mapLinkedReference, r, quantityRatio);
    }),
  );
  return reference;
}
export function isTractionBatteryBeingAdded(vehicleRefsLocal: ReferenceLocal[]): boolean {
  return vehicleRefsLocal.some((ref) => {
    const familyCode = ref.source === 'dh' ? ref.familyCode : ref.commercialFamily;
    return isSingleUnitOrderRestrictedFamily(familyCode);
  });
}

export function* isTractionBatteryBlockedForVehicle(
  vehicleRefsLocal: ReferenceLocal[],
  vehicleKey: string,
): SagaIterator<boolean> {
  if (!isTractionBatteryBeingAdded(vehicleRefsLocal)) {
    return false;
  }
  return yield* select((state: RootState) => getBasketHasTractionBatteryForVehicle(state, vehicleKey));
}

export function* handleTractionBatterySingleUnitViolation(vehicleRefsLocal: ReferenceLocal[]): SagaIterator {
  yield call(
    notifyTop,
    'error',
    AppTranslation.t(
      'cart.action.add_reference.traction_battery_already_in_basket',
      'This vehicle already has a traction battery in the cart',
    ),
  );
  for (const ref of vehicleRefsLocal) {
    const familyCode = ref.source === 'dh' ? ref.familyCode : ref.commercialFamily;
    if (isSingleUnitOrderRestrictedFamily(familyCode)) {
      yield put(
        setActionStatus({
          reference: ref.referenceNumber,
          status: STATUS_TRACTION_BATTERY_ALREADY_IN_BASKET,
        }),
      );
    }
  }
}

function getReferenceFamilyCode(
  reference: ReturnType<typeof getDHReference> | ReturnType<typeof getIAMReference>,
): string | undefined {
  const referenceData = getData(reference);

  if (!referenceData) {
    return undefined;
  }

  return referenceData.source === 'dh'
    ? referenceData.familyCode ?? undefined
    : referenceData.commercialFamily ?? undefined;
}

function getReferenceSegmentMarketing(
  reference: ReturnType<typeof getDHReference> | ReturnType<typeof getIAMReference>,
): string | undefined {
  const referenceData = getData(reference);

  if (referenceData?.source !== 'dh') {
    return undefined;
  }

  return referenceData.segmentMarketing ?? undefined;
}

function* getCrossSellingOrigin(
  triggerReferenceNumber: string | undefined,
  catalogSource: 'DATAHUB' | 'IAM',
  vehicleKey?: string,
): SagaIterator<CrossSellingOriginContext | undefined> {
  if (!triggerReferenceNumber) {
    return undefined;
  }

  const triggerReference = yield* select((state: RootState) =>
    catalogSource === 'DATAHUB'
      ? getDHReference(state, {
          referenceNumber: triggerReferenceNumber,
          vehicleKey,
        }) ??
        getDHReference(state, {
          referenceNumber: triggerReferenceNumber,
          vehicleKey: undefined,
        })
      : getIAMReference(state, {
          referenceNumber: triggerReferenceNumber,
          vehicleKey,
        }) ??
        getIAMReference(state, {
          referenceNumber: triggerReferenceNumber,
          vehicleKey: undefined,
        }),
  );

  return {
    mainReferenceNumber: triggerReferenceNumber,
    mainReferenceFamilyCode: getReferenceFamilyCode(triggerReference),
    mainReferenceSegmentMarketing: getReferenceSegmentMarketing(triggerReference),
  };
}

function buildCrossSellingAddToBasketTrackedReferences(
  basketId: string,
  references: CrossSellingRequestReference[],
  crossSellingOrigin: CrossSellingOriginContext,
  contextType: 'VEHICLE' | 'OTHER',
  isFromProductPage: boolean,
): CrossSellingAddToBasketTrackedReference[] {
  return references.map((reference) => ({
    basketId,
    triggerReferenceNumber: crossSellingOrigin.mainReferenceNumber ?? '',
    triggerReferenceFamilyCode: crossSellingOrigin.mainReferenceFamilyCode,
    triggerReferenceSegmentMarketing: crossSellingOrigin.mainReferenceSegmentMarketing,
    crossSellingReferenceNumber: reference.referenceNumber,
    crossSellingReferenceName: reference.name,
    crossSellingReferenceFamilyCode: reference.familyCode,
    crossSellingReferenceSegmentMarketing: reference.segmentMarketing,
    crossSellingReferenceGaragePriceVatIncluded: reference.price?.priceVatIncluded,
    crossSellingReferenceGaragePriceVatExcluded: reference.price?.priceVatExcluded,
    crossSellingAddedQuantity: reference.quantity,
    contextType,
    location: isFromProductPage ? 'product' : 'catalog',
  }));
}

function resolveRefsForVehicle(
  vehicleRefsLocal: ReferenceLocal[],
  otherRefsLocal: ReferenceLocal[] | undefined,
): ReferenceLocal[] {
  return vehicleRefsLocal.length > 0 ? vehicleRefsLocal : otherRefsLocal ?? [];
}

export function* addReferenceRequest({ payload }: ReturnType<typeof actions.addReferenceRequest>): SagaIterator {
  const { isCrossSellReference = false, isFromProductPage = false } = payload;
  const referenceNumbers = payload.referenceNumber;
  const { sellerNumber, sellerName } = payload;
  const triggerReferenceNumber = payload.mainReferenceNumber;
  const dhPlateReference = payload.index ? payload : undefined;
  const vehicleDetail = yield* select(getLastVehicleDetail);

  const dhPlateReferencesData: PlateReferencesDetail | undefined =
    dhPlateReference && vehicleDetail?.vehicleKey
      ? getData(
          yield* select((state: RootState) =>
            getPlateReference(state, {
              plateId: dhPlateReference.plateId,
              vehicleKey: vehicleDetail.vehicleKey,
              index: dhPlateReference.index,
            }),
          ),
        )
      : undefined;

  const vehicleRefsLocal: ReferenceLocal[] =
    vehicleDetail?.vehicleKey === undefined
      ? []
      : yield* select((state: RootState) =>
          vehicleDetail.catalogSource === 'DATAHUB'
            ? getDHReferences(state, { referenceNumbers: [referenceNumbers], vehicleKey: vehicleDetail.vehicleKey })
            : getIAMReferences(state, { referenceNumbers: [referenceNumbers], vehicleKey: vehicleDetail.vehicleKey }),
        );

  const otherRefsLocal: ReferenceLocal[] | undefined =
    vehicleRefsLocal.length > 0
      ? undefined
      : yield* select((state: RootState) =>
          vehicleDetail?.catalogSource === 'DATAHUB'
            ? getDHReferences(state, { referenceNumbers: [referenceNumbers], vehicleKey: undefined })
            : getIAMReferences(state, { referenceNumbers: [referenceNumbers], vehicleKey: undefined }),
        );

  // No vehicle context → add to other section and do not continue
  if (!vehicleDetail && otherRefsLocal !== undefined) {
    yield all(
      otherRefsLocal.map((reference) =>
        put(
          actions.addOtherSectionReferenceRequest({
            reference: {
              ...reference,
              isCrossSelling: isCrossSellReference,
              mainReferenceNumber: triggerReferenceNumber,
              sellerNumber,
              sellerName,
            },
          }),
        ),
      ),
    );
    return;
  }

  // Vehicle  context present: prefer vehicle refs, fall back to non-vehicle ref data for vehicle section
  const refsForVehicle = resolveRefsForVehicle(vehicleRefsLocal, otherRefsLocal);

  // Add to vehicle section
  if (!vehicleDetail || refsForVehicle.length === 0) return;

  // Single-unit restriction: check if adding a traction battery when one already exists in basket
  const tractionBatteryBlocked: boolean = yield call(
    isTractionBatteryBlockedForVehicle,
    refsForVehicle,
    vehicleDetail.vehicleKey,
  );
  if (tractionBatteryBlocked) {
    yield call(handleTractionBatterySingleUnitViolation, refsForVehicle);
    return;
  }

  const basketId = yield* select(getBasketId);
  const userContext = yield* select(getUserContext);
  const vehicleContext = yield* select((state: RootState) => getVehicleContext(state, vehicleDetail.vehicleKey));
  const crossSellingOrigin =
    isCrossSellReference && triggerReferenceNumber
      ? yield call(getCrossSellingOrigin, triggerReferenceNumber, vehicleDetail.catalogSource, vehicleDetail.vehicleKey)
      : undefined;

  const references: CrossSellingRequestReference[] = yield all(
    refsForVehicle.map((r) =>
      call(mapReferences, r, getData(dhPlateReferencesData), vehicleDetail?.vehicleKey, {
        isCrossSelling: isCrossSellReference,
        isFromProductPage,
        crossSellingOrigin,
        sellerNumber,
        sellerName,
      }),
    ),
  );

  if (basketId && crossSellingOrigin?.mainReferenceNumber) {
    yield put(
      actions.crossSellingAddToBasketTracked({
        references: buildCrossSellingAddToBasketTrackedReferences(
          basketId,
          references,
          crossSellingOrigin,
          'VEHICLE',
          isFromProductPage,
        ),
      }),
    );
  }

  yield put(addVehicleReferences({ vehicleDetail, references: references as BasketReferenceLocal[] }));
  yield put(
    sendAddReferences({
      basketId,
      userContext,
      vehicleContext,
      references,
      vehicleDetail,
    }),
  );
}

export function* addReferenceUnderVehicleRequest({
  payload,
}: ReturnType<typeof actions.addReferenceUnderVehicleRequest>): SagaIterator {
  const { catalogSource, referenceToAdd } = payload;
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const references = yield* select((state: RootState) =>
    catalogSource === 'DATAHUB'
      ? getDHReferences(state, { referenceNumbers: [referenceToAdd.referenceNumber], vehicleKey: undefined })
      : getIAMReferences(state, { referenceNumbers: [referenceToAdd.referenceNumber], vehicleKey: undefined }),
  );

  // Add to vehicle section
  if (!vehicleDetail || references?.length === 0) return;
  const basketId = yield* select(getBasketId);
  const userContext = yield* select(getUserContext);
  const vehicleContext = yield* select((state: RootState) => getVehicleContext(state, vehicleDetail.vehicleKey));
  const reference = references[0];
  const referenceDetail: RQReference = yield call(
    mapReferences,
    reference,
    undefined,
    vehicleDetail.vehicleKey,
    undefined,
  );

  yield put(addVehicleReferences({ vehicleDetail, references: [referenceDetail] }));
  yield put(
    sendAddReferences({
      basketId,
      userContext,
      vehicleContext,
      references: [referenceDetail],
      vehicleDetail,
    }),
  );
}

export function* addEasyBasketReferenceRequest({
  payload,
}: ReturnType<typeof actions.addEasyBasketReferenceRequest>): SagaIterator {
  const { selectedReference } = payload;
  const vehicleDetail = yield* select(getLastVehicleDetail);

  const references = yield* select((state: RootState) =>
    getDHReferences(state, {
      referenceNumbers: [selectedReference.referenceNumber],
      vehicleKey: vehicleDetail?.vehicleKey,
    }),
  );

  // Add to vehicle section
  if (!vehicleDetail || references?.length === 0) {
    return;
  }
  const basketId = yield* select(getBasketId);
  const userContext = yield* select(getUserContext);
  const vehicleContext = yield* select((state: RootState) => getVehicleContext(state, vehicleDetail.vehicleKey));

  const reference = references[0];
  const referenceDetail: RQReference = yield call(mapReferences, reference, undefined, vehicleDetail.vehicleKey);

  const updatedReferencesDetails: RQReference = {
    ...referenceDetail,
    quantity: selectedReference.quantity,
  };

  yield put(addVehicleReferences({ vehicleDetail, references: [referenceDetail] }));
  yield put(
    sendAddReferences({
      basketId,
      userContext,
      vehicleContext,
      references: [updatedReferencesDetails],
      vehicleDetail,
    }),
  );
}

export function* addTireRequest({ payload }: ReturnType<typeof actions.addTireRequest>): SagaIterator {
  const tire = payload;
  const basketId = yield* select(getBasketId);
  const tireSetParam = yield* select(getTireSetParam);
  const discount = yield* select((state: RootState) => getDiscount(state, tire.partNumber));
  const priceSelect = yield* select((state: RootState) => getPrice(state, tire.partNumber));
  const price = getData(priceSelect);
  const userContext = yield* select(getUserContext);

  if (!price) return;
  const reference = mapTire(tire, price, discount, tireSetParam);

  yield put(addOtherReference({ reference }));
  yield put(
    sendAddReferences({
      basketId,
      userContext,
      references: [reference],
    }),
  );
}

export function* addOtherReferenceRequest({
  payload,
}: ReturnType<typeof actions.addOtherReferenceRequest>): SagaIterator {
  const ref = yield* select((state: RootState) =>
    payload.isDH || isRefNumberDeposit(payload.reference)
      ? getDHReference(state, { referenceNumber: payload.reference, vehicleKey: undefined })
      : getIAMReference(state, { referenceNumber: payload.reference, vehicleKey: undefined }),
  );

  const reference = getData(ref);
  if (reference !== undefined) {
    yield put(
      actions.addOtherSectionReferenceRequest({
        reference: {
          ...reference,
          sellerNumber: payload.sellerNumber,
          sellerName: payload.sellerName,
        },
      }),
    );
  }
}

export function* addOtherSectionReferenceRequest({
  payload,
}: ReturnType<typeof actions.addOtherSectionReferenceRequest>): SagaIterator {
  const referenceLocal = payload.reference;
  if (!referenceLocal) return;

  const triggerReference =
    referenceLocal.isCrossSelling && referenceLocal.mainReferenceNumber
      ? yield* select((state: RootState) =>
          referenceLocal.source === 'dh'
            ? getDHReference(state, {
                referenceNumber: referenceLocal.mainReferenceNumber,
                vehicleKey: undefined,
              })
            : getIAMReference(state, {
                referenceNumber: referenceLocal.mainReferenceNumber,
                vehicleKey: undefined,
              }),
        )
      : undefined;
  const crossSellingOrigin =
    referenceLocal.isCrossSelling && referenceLocal.mainReferenceNumber
      ? {
          mainReferenceNumber: referenceLocal.mainReferenceNumber,
          mainReferenceFamilyCode: getReferenceFamilyCode(triggerReference),
          mainReferenceSegmentMarketing: getReferenceSegmentMarketing(triggerReference),
        }
      : undefined;

  const basketId = yield* select(getBasketId);
  const userContext = yield* select(getUserContext);

  const reference: CrossSellingRequestReference = yield call(mapReferences, referenceLocal, undefined, undefined, {
    isCrossSelling: !!referenceLocal.isCrossSelling,
    isFromProductPage: !!referenceLocal.isFromProductPage,
    crossSellingOrigin,
  });

  yield put(
    actions.addOtherReference({
      reference,
    }),
  );

  if (referenceLocal.isCrossSelling && referenceLocal.mainReferenceNumber) {
    const trackedBasketId = basketId;
    if (trackedBasketId && crossSellingOrigin?.mainReferenceNumber) {
      yield put(
        actions.crossSellingAddToBasketTracked({
          references: buildCrossSellingAddToBasketTrackedReferences(
            trackedBasketId,
            [reference],
            crossSellingOrigin,
            'OTHER',
            !!referenceLocal.isFromProductPage,
          ),
        }),
      );
    }
  }

  yield put(
    sendAddReferences({
      basketId,
      userContext,
      references: [reference],
    }),
  );
}

export function* addReferenceByRefNumberRequest({
  payload,
}: ReturnType<typeof actions.addReferenceByRefNumberRequest>): SagaIterator {
  const { reference } = payload;
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const basketIdStatus = yield* select(getBasketIdStatus);
  const basketId = basketIdStatus === FOUND ? yield* select(getBasketId) : undefined;
  const userContext = yield* select(getUserContext);

  yield put(
    setActionStatus({
      reference,
      status: LOADING,
    }),
  );

  yield put(sendAddReferenceByRefNumber(basketId, reference, userContext, vehicleDetail));
}

type AddRefByRefNumberResult =
  | 'OK'
  | 'MISSING_PRICE'
  | 'NOT_IN_STOCK'
  | 'UNKNOWN_REFERENCE'
  | 'REFERENCE_DOES_NOT_EXIST'
  | 'NOT_ALLOWED'
  | 'VIN_NON_COMPLIANT'
  | 'ZE_READY_REQUIRED';

const mapAddRefByRefNumberStatus = (responseResult: AddRefByRefNumberResult) => {
  switch (responseResult) {
    case 'OK':
      return STATUS_SUCCESS;
    case 'UNKNOWN_REFERENCE':
      return STATUS_UNKNOWN_REFERENCE;
    case 'MISSING_PRICE':
      return STATUS_MISSING_PRICE;
    case 'NOT_IN_STOCK':
      return STATUS_NOT_IN_STOCK;
    case 'REFERENCE_DOES_NOT_EXIST':
      return STATUS_REFERENCE_DOES_NOT_EXIST;
    case 'NOT_ALLOWED':
      return STATUS_NOT_ALLOWED;
    case 'VIN_NON_COMPLIANT':
      return STATUS_VIN_NON_COMPLIANT;
    case 'ZE_READY_REQUIRED':
      return STATUS_ZE_READY_REQUIRED;
    default:
      return STATUS_UNKNOWN_REFERENCE;
  }
};

export function* addReferenceByRefNumberResponse(action: WsResponse<AddReferenceByRefNumber>): SagaIterator {
  const { referenceNumber, result } = action.payload;
  const vehicles = yield* select(getBasketVehicles);
  const otherSection = yield* select(getBasketOtherSection);
  const hasTractionBatteryInBasket =
    vehicles.some((vehicle) =>
      vehicle.references.some((reference) => isSingleUnitOrderRestrictedFamily(reference.familyCode)),
    ) || otherSection.references.some((reference) => isSingleUnitOrderRestrictedFamily(reference.familyCode));
  const status =
    result === 'NOT_ALLOWED' && hasTractionBatteryInBasket
      ? STATUS_TRACTION_BATTERY_ALREADY_IN_BASKET
      : mapAddRefByRefNumberStatus(result);

  if (status === STATUS_NOT_ALLOWED) {
    const userRoles = yield* select(getUserRights);
    const normalizedUserRoles = Array.isArray(userRoles) ? userRoles : [];
    const isR3OrR3Motrio = hasUserAnyRight(['R3' as UserRole, 'R3_MOTRIO' as UserRole], normalizedUserRoles);
    const reason = isR3OrR3Motrio ? ('r3_restricted' as const) : ('vin_required' as const);
    const message = getTractionBatteryBlockedMessage(reason);
    if (message) {
      yield call(notifyTop, 'error', AppTranslation.t(message.key, message.defaultMessage));
    }
  }

  if (status === STATUS_VIN_NON_COMPLIANT) {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        'cart.action.add_reference.traction_battery_vin_non_compliant',
        TRACTION_BATTERY_VIN_NON_COMPLIANT_DEFAULT_MESSAGE,
      ),
    );
  }

  if (status === STATUS_ZE_READY_REQUIRED) {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        'cart.action.add_reference.traction_battery_ze_ready_required',
        'ZE-Ready homologation is required to purchase this product',
      ),
    );
  }

  if (status === STATUS_TRACTION_BATTERY_ALREADY_IN_BASKET) {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        'cart.action.add_reference.traction_battery_already_in_basket',
        'This vehicle already has a traction battery in the cart',
      ),
    );
  }

  yield put(
    setActionStatus({
      reference: referenceNumber,
      status,
    }),
  );
}

export function* removeReferencesRequest({
  payload,
}: ReturnType<typeof actions.removeReferencesRequest>): SagaIterator {
  const { vehiclesWithReferences, otherReferences, externalBasketsWithReferences } = payload;
  const basketId = yield* select(getBasketId);

  if (!basketId) return;

  yield put(removeReferences({ vehiclesWithReferences, otherReferences, externalBasketsWithReferences }));
  yield put(
    sendRemoveReferencesRequest({
      externalBasketsWithReferences: [],
      vehiclesWithReferences: [],
      otherReferences: [],
      ...payload,
      basketId,
    }),
  );
}

export function* removeSingleReferenceRequest({
  payload,
}: ReturnType<typeof actions.removeSingleReferenceRequest>): SagaIterator {
  const { basketReferenceType, vehicleKey, referenceKey, externalBasketId } = payload;
  const basketId = yield* select(getBasketId);

  if (!basketId) return;

  const stock = yield* select((state: RootState) =>
    getStockInfo(state, referenceKey.referenceNumber, referenceKey.sellerNumber),
  );
  const stockData = getSearchData(stock);
  yield put(removeReference({ basketReferenceType, vehicleKey, referenceToRemove: referenceKey, externalBasketId }));
  yield put(
    sendRemoveSingleReference({
      ...payload,
      basketId,
      reference: referenceKey.referenceNumber,
      sellerNumber: referenceKey.sellerNumber,
      stockDetail: {
        warehouses: stockData?.warehouses ?? [],
      },
    }),
  );
}

export function* revertLastRemovalRequest(): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(sendRevertLastRemoval({ basketId }));
}

export function* updateOrderMarkRequest({ payload }: ReturnType<typeof actions.updateOrderMarkRequest>): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(sendUpdateOrderMark({ ...payload, basketId }));
}

export function* updateReferenceMarkRequest({
  payload,
}: ReturnType<typeof actions.updateReferenceMarkRequest>): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(
    sendSetReferenceMark({
      ...payload,
      basketId,
      referenceNumber: payload.referenceToUpdate.referenceNumber,
      sellerNumber: payload.referenceToUpdate.sellerNumber,
    }),
  );
}

const findReference = (
  vehicleKey: string | undefined,
  vehicles: VehicleLocal[],
  externalBasket: ExternalBasketSectionLocal | undefined,
  otherSection: OtherSectionLocal,
  referenceToFind: ReferenceKey,
): Reference | undefined => {
  if (vehicleKey) {
    const vehicle = vehicles.find((veh) => veh.vehicleDetail.vehicleKey === vehicleKey);
    return vehicle?.references?.find((ref) => matchesReferenceKey(ref, referenceToFind));
  }

  if (externalBasket) {
    return externalBasket.references.find((ref) => matchesReferenceKey(ref, referenceToFind));
  }

  return otherSection.references.find((ref) => matchesReferenceKey(ref, referenceToFind));
};

export function* updateReferenceQuantityRequest({
  payload,
}: ReturnType<typeof actions.updateReferenceQuantityRequest>): SagaIterator {
  const { vehicleKey, referenceToUpdate, newQuantity, externalBasketId } = payload;
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  const vehicles = yield* select(getBasketVehicles);
  const otherSection = yield* select(getBasketOtherSection);
  const externalSections = yield* select(getBasketExternalSection);
  const externalBasket = externalBasketId
    ? externalSections.find((e) => e.externalBasketId === externalBasketId)
    : undefined;
  const reference = findReference(vehicleKey, vehicles, externalBasket, otherSection, referenceToUpdate);

  const originalQuantity = reference?.quantity ?? 1;
  if (originalQuantity === newQuantity) {
    return;
  }
  const userContext = yield* select(getUserContext);
  yield put(updateReferenceQuantity({ vehicleKey, referenceToUpdate, newQuantity, externalBasketId }));
  yield put(
    sendUpdateReferenceQuantity({
      ...payload,
      userContext,
      basketId,
      originalQuantity,
      type: payload.referenceType,
      referenceNumber: payload.referenceToUpdate.referenceNumber,
      sellerNumber: payload.referenceToUpdate.sellerNumber,
    }),
  );
}

export function* uploadFileReferencesRequest({
  payload,
}: ReturnType<typeof actions.uploadFileReferencesRequest>): SagaIterator {
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const userContext = yield* select(getUserContext);
  const basketId = yield* select(getBasketId);
  yield put(sendUploadReferencesFileRequest({ ...payload, userContext, basketId, vehicleDetail }));

  // Safety net: never leave the upload spinner hanging if no backend response arrives.
  const { timeout } = yield race({
    response: take([
      UPLOAD_BASKET_REFERENCES_FILE_RESPONSE,
      UPLOAD_BASKET_REFERENCES_FILE_ERROR_99_REFERENCES,
      UPLOAD_BASKET_REFERENCES_FILE_ERROR_API_CALL,
      UPLOAD_BASKET_REFERENCES_FILE_ERROR_TECHNICAL,
    ]),
    timeout: delay(UPLOAD_REFERENCES_FILE_TIMEOUT_MS),
  });

  if (timeout) {
    yield put(setFileReferencesUploadStatusModalStatus(TECHNICAL_ERROR));
  }
}

export function* uploadFileReferencesResponse(action: WsResponse<UploadReferencesFileResponse>): SagaIterator {
  const { errorRows } = action.payload;

  const tractionBatteryUploadMessages = getTractionBatteryUploadErrorMessages(errorRows);
  for (const message of tractionBatteryUploadMessages) {
    yield call(notifyTop, 'error', AppTranslation.t(message.key, message.defaultMessage), null);
  }

  yield put(setFileReferencesUploadStatusErrorRows(errorRows));
  yield put(setFileReferencesUploadStatusIsModalOpen(false));
  yield put(setFileReferencesUploadStatusModalStatus(NO_FILE));
  yield put(sendGetBasket());
}

export function* updateUrgencyFlagRequest({
  payload,
}: ReturnType<typeof actions.updateUrgencyFlagRequest>): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(sendUpdateUrgencyFlag({ ...payload, basketId }));
}

export function* updateAllUrgencyFlagsRequest({
  payload,
}: ReturnType<typeof actions.updateAllUrgencyFlagsRequest>): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(sendUpdateAllUrgencyFlags({ ...payload, basketId }));
}

export function* confirmMoveNonCompatibleOtherSectionReferenceToVehicleResponse(
  action: WsResponse<OtherReferenceMoveToVehicleConfirmResponse>,
): SagaIterator {
  const { otherSectionReference, targetVehicleKey } = action.payload;

  if (otherSectionReference && targetVehicleKey) {
    yield put(
      setOtherReferenceAttachStatus({
        reference: { referenceNumber: otherSectionReference, sellerNumber: undefined },
        vehicleKey: targetVehicleKey,
        type: REF_ATTACH_NON_COMPATIBLE,
      }),
    );
  }
}

export function* attachOtherReferenceToVehicleRequest({
  payload,
}: ReturnType<typeof actions.attachOtherReferenceToVehicleRequest>): SagaIterator {
  const { vehicleKey, reference } = payload;
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  const userContext = yield* select(getUserContext);
  yield put(setOtherReferenceAttachStatus({ reference, vehicleKey, type: REF_ATTACH_CHECKING }));
  yield put(attachOtherReferenceToVehicle(basketId, vehicleKey, reference.referenceNumber, userContext));
}

export function* attachOtherNonApplicableReferenceToVehicleRequest({
  payload,
}: ReturnType<typeof actions.attachOtherNonApplicableReferenceToVehicleRequest>): SagaIterator {
  const { vehicleKey, reference } = payload;
  if (!vehicleKey) return;
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  const userContext = yield* select(getUserContext);
  yield put(setOtherReferenceAttachStatus({ reference, vehicleKey, type: REF_ATTACH_CHECKING }));
  yield put(attachOtherNonApplicableReferenceToVehicle(basketId, vehicleKey, reference.referenceNumber, userContext));
}

export function* otherSectionReferenceMovedToVehicleResponse(
  action: WsResponse<OtherReferenceMoveToVehicleResponse>,
): SagaIterator {
  const payload = action.payload;
  const { otherSectionReference, targetVehicleKey, isCompatible } = payload;

  if (otherSectionReference) {
    yield put(
      moveOtherReferenceToVehicle({
        vehicleKey: targetVehicleKey,
        reference: { referenceNumber: otherSectionReference },
        isCompatible,
      }),
    );
    yield put(
      setOtherReferenceAttachStatus({
        reference: { referenceNumber: payload.otherSectionReference, sellerNumber: undefined },
        vehicleKey: targetVehicleKey,
        type: REF_ATTACH_OK,
      }),
    );
  }
}

export function* revertMoveOtherReferenceToVehicle(): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(sendRevertAttachOtherReference({ basketId }));
}

export function* notifyUserAboutExpiredDiscountsRequest(): SagaIterator {
  const basketId = yield* select(getBasketId);
  if (!basketId) return;
  yield put(notifyUserAboutExpiredDiscounts({ basketId }));
}

export function* handleInvalidReferenceQuantityUpdate(
  action: WsResponse<InvalidReferenceQuantityUpdateResponse>,
): SagaIterator {
  const {
    referenceNumber,
    requestedQuantity,
    originalQuantity,
    externalBasketId,
    vehicleKey,
    sellerNumber,
  } = action.payload;
  const vehicles = yield* select(getBasketVehicles);
  const otherSection = yield* select(getBasketOtherSection);
  const externalSections = yield* select(getBasketExternalSection);
  const externalBasket = externalBasketId
    ? externalSections.find((e) => e.externalBasketId === externalBasketId)
    : undefined;
  const referenceKey = { referenceNumber, sellerNumber };
  const reference = findReference(vehicleKey, vehicles, externalBasket, otherSection, referenceKey);
  const currentQuantity = reference?.quantity ?? 0;

  if (currentQuantity === requestedQuantity) {
    yield put(
      updateReferenceQuantity({
        vehicleKey,
        referenceToUpdate: { referenceNumber, sellerNumber },
        externalBasketId,
        newQuantity: originalQuantity,
      }),
    );
  }

  if (requestedQuantity > originalQuantity) {
    yield call(
      notifyTop,
      'warning',
      AppTranslation.t(
        'cart.action.update_quantity.stock_validation_quantity_not_available.notification.title',
        'Selected quantity for reference {{ referenceNumber }} is not available',
        {
          referenceNumber,
        },
      ) as string,
    );
  } else {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        'cart.action.update_quantity.stock_validation_failed.notification.title',
        'Failed to update reference quantity',
      ),
      AppTranslation.t(
        'cart.action.update_quantity.stock_validation_failed.notification.description',
        'Failed to check stocks for reference {{ referenceNumber }}, please try again later ',
        {
          referenceNumber,
        },
      ) as string,
    );
  }
}

export function* BasketSagas(): SagaIterator {
  yield takeEvery(actions.fetchBasketRequest.type, sagaGuard(fetchBasketRequest));
  yield takeEvery(actions.fetchBasketResponse.type, sagaGuard(fetchBasketResponse));
  yield takeEvery(actions.handleInvalidReferenceQuantityUpdate.type, sagaGuard(handleInvalidReferenceQuantityUpdate));
  yield takeEvery(actions.addReferenceRequest.type, sagaGuard(addReferenceRequest));
  yield takeEvery(actions.addReferenceUnderVehicleRequest.type, sagaGuard(addReferenceUnderVehicleRequest));
  yield takeEvery(actions.addEasyBasketReferenceRequest.type, sagaGuard(addEasyBasketReferenceRequest));
  yield takeEvery(actions.addTireRequest.type, sagaGuard(addTireRequest));
  yield takeEvery(actions.addOtherReferenceRequest.type, sagaGuard(addOtherReferenceRequest));
  yield takeEvery(actions.addOtherSectionReferenceRequest.type, sagaGuard(addOtherSectionReferenceRequest));
  yield takeEvery(actions.addReferenceByRefNumberRequest.type, sagaGuard(addReferenceByRefNumberRequest));
  yield takeEvery(actions.addReferenceByRefNumberResponse.type, sagaGuard(addReferenceByRefNumberResponse));
  yield takeEvery(actions.removeReferencesRequest.type, sagaGuard(removeReferencesRequest));
  yield takeEvery(actions.removeSingleReferenceRequest.type, sagaGuard(removeSingleReferenceRequest));
  yield takeEvery(actions.revertLastRemovalRequest.type, sagaGuard(revertLastRemovalRequest));
  yield takeEvery(actions.updateReferenceQuantityRequest.type, sagaGuard(updateReferenceQuantityRequest));
  yield takeEvery(actions.updateOrderMarkRequest.type, sagaGuard(updateOrderMarkRequest));
  yield takeEvery(actions.updateReferenceMarkRequest.type, sagaGuard(updateReferenceMarkRequest));
  yield takeEvery(actions.uploadFileReferencesRequest.type, sagaGuard(uploadFileReferencesRequest));
  yield takeEvery(actions.uploadFileReferencesResponse.type, sagaGuard(uploadFileReferencesResponse));
  yield takeEvery(actions.updateUrgencyFlagRequest.type, sagaGuard(updateUrgencyFlagRequest));
  yield takeEvery(actions.updateAllUrgencyFlagsRequest.type, sagaGuard(updateAllUrgencyFlagsRequest));
  yield takeEvery(actions.attachOtherReferenceToVehicleRequest.type, sagaGuard(attachOtherReferenceToVehicleRequest));
  yield takeEvery(
    actions.attachOtherNonApplicableReferenceToVehicleRequest.type,
    sagaGuard(attachOtherNonApplicableReferenceToVehicleRequest),
  );
  yield takeEvery(
    actions.confirmMoveNonCompatibleOtherSectionReferenceToVehicleResponse.type,
    sagaGuard(confirmMoveNonCompatibleOtherSectionReferenceToVehicleResponse),
  );
  yield takeEvery(
    actions.otherSectionReferenceMovedToVehicleResponse.type,
    sagaGuard(otherSectionReferenceMovedToVehicleResponse),
  );
  yield takeEvery(actions.revertMoveOtherReferenceToVehicle.type, sagaGuard(revertMoveOtherReferenceToVehicle));
  yield takeEvery(
    actions.notifyUserAboutExpiredDiscountsRequest.type,
    sagaGuard(notifyUserAboutExpiredDiscountsRequest),
  );
}
